// Build a Schema.org BreadcrumbList JSON-LD object from a simple
// array of [{name, path}] segments. Pass the result to useSEO({ jsonLd }).
import { SITE_URL } from "./data";

export function buildBreadcrumbs(segments) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: segments.map((s, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: s.name,
      item: `${SITE_URL}${s.path}`,
    })),
  };
}
